var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnchor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "874px",
    height: "874px",
    viewBox: "0 0 874 874",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WoW-Book-Icons",
    transform: "translate(-1302.000000, -4344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin-Copy",
    transform: "translate(1303.000000, 4345.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#00D2C9",
    x: 0,
    y: 0,
    width: 872,
    height: 872,
    rx: 92
  }), /*#__PURE__*/React.createElement("g", {
    id: "map-pin-copy",
    transform: "translate(296.558250, 180.441750)",
    fill: "#616063",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,144 C288,223.5 223.5,288 144,288 C64.47,288 0,223.5 0,144 C0,64.47 64.47,0 144,0 C223.5,0 288,64.47 288,144 Z M160,64 C160,55.16 152.8,48 144,48 C90.1,48 48,90.98 48,144 C48,152.8 55.16,160 64,160 C72.8,160 80,152.8 80,144 C80,108.7 108.7,80 144,80 C152.8,80 160,72.84 160,64 Z M112,480 L112,317.1 C122.4,319 133.1,319.1 144,319.1 C154.9,319.1 165.6,319 176,317.1 L176,480 C176,497.7 161.7,512 144,512 C126.3,512 112,497.7 112,480 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "map-pin",
    transform: "translate(291.558250, 175.441750)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,144 C288,223.5 223.5,288 144,288 C64.47,288 0,223.5 0,144 C0,64.47 64.47,0 144,0 C223.5,0 288,64.47 288,144 Z M160,64 C160,55.16 152.8,48 144,48 C90.1,48 48,90.98 48,144 C48,152.8 55.16,160 64,160 C72.8,160 80,152.8 80,144 C80,108.7 108.7,80 144,80 C152.8,80 160,72.84 160,64 Z M112,480 L112,317.1 C122.4,319 133.1,319.1 144,319.1 C154.9,319.1 165.6,319 176,317.1 L176,480 C176,497.7 161.7,512 144,512 C126.3,512 112,497.7 112,480 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor);
export default __webpack_public_path__ + "static/media/Anchor.b1b4d92989059de864154a5e35c2e3f2.svg";
export { ForwardRef as ReactComponent };